import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  generateSocialPost,
  publishSocialPost,
  getSocialPost,
  getSocialPosts,
  GeneratePostPayload,
} from 'services/social.service';

export const socialPostsQueryKey = 'socialPosts';

export const useSocialPosts = (params: { skip: number; limit: number }) => useQuery(
  [socialPostsQueryKey, params],
  () => getSocialPosts(params).then((r) => r.data),
  { refetchOnWindowFocus: false },
);

export const useSocialPostById = (id: string) => useQuery(
  [socialPostsQueryKey, id],
  () => getSocialPost(id).then((r) => r.data),
  { enabled: !!id, refetchOnWindowFocus: false },
);

export const useGenerateSocialPost = () => useMutation((payload: GeneratePostPayload) => generateSocialPost(payload).then((r) => r.data));

export const usePublishSocialPost = () => {
  const qc = useQueryClient();
  return useMutation(
    (id: string) => publishSocialPost(id).then((r) => r.data),
    { onSuccess: () => qc.invalidateQueries(socialPostsQueryKey) },
  );
};
